import React from 'react';
import type { SequenceHUDProps } from './sequenceHUD.types';
import './SequenceHUD.styles.css';

// * [COMPONENT] Unified Sequence HUD overlay displaying Recruiter Mode (top-right) and Zoom controls (bottom-right)
// ? Stays permanently mounted and interactive across all 5 portfolio sections (Home, About, Projects, Experience, Achievements)
export const SequenceHUD: React.FC<SequenceHUDProps> = ({
  scale,
  onZoomIn,
  onZoomOut,
  isRecruiterActive,
  onRecruiterToggle,
  recruiterLabel = 'Recruiter Mode',
  showRecruiterTooltip = false,
  className = '',
}) => {
  return (
    <div className={`sequence-hud-root ${className}`}>
      {/* * Floating Recruiter Mode Pill Button & Suggestion Tooltip (Top Right) */}
      <div className="recruiter-pill-wrapper">
        <button
          type="button"
          className="recruiter-pill"
          onClick={onRecruiterToggle}
          aria-label="Toggle Recruiter Mode"
          aria-pressed={isRecruiterActive}
          title="Toggle Recruiter Mode"
        >
          <span
            className={`status-dot ${isRecruiterActive ? 'green' : 'red'}`}
            aria-hidden="true"
          />
          <span>{recruiterLabel}</span>
        </button>

        {showRecruiterTooltip && !isRecruiterActive && (
          <div
            className="recruiter-end-tooltip"
            role="status"
            aria-live="polite"
            onClick={onRecruiterToggle}
          >
            <div className="tooltip-arrow" />
            <span className="tooltip-badge">Tip</span>
            <span className="tooltip-text">
              Recruiter? <strong>Enable this</strong> to unlock Experience & Timeline
            </span>
          </div>
        )}
      </div>

      {/* * Floating Interactive UI Scaling Controls (+ and -) (Bottom Right) */}
      <aside
        className="sequence-scale-controls"
        aria-label="Adjust section element and font size"
      >
        <button
          type="button"
          className="sequence-scale-btn"
          onClick={onZoomOut}
          aria-label="Decrease element and font size"
          title="Zoom out (reduce size)"
        >
          −
        </button>
        <span className="sequence-scale-indicator">
          {Math.round(scale * 100)}%
        </span>
        <button
          type="button"
          className="sequence-scale-btn"
          onClick={onZoomIn}
          aria-label="Increase element and font size"
          title="Zoom in (increase size)"
        >
          +
        </button>
      </aside>
    </div>
  );
};

export default SequenceHUD;
